import { cn } from '@/lib/utils'
import React from 'react'
import { Link as LinkRouter } from 'react-router-dom'

export type LinkProps = React.ComponentProps<'a'> & {
    /** Sublinhado do texto, como no `Link` do MUI. */
    underline?: 'none' | 'hover' | 'always'
}

const sublinhado = {
    none: 'no-underline',
    hover: 'no-underline hover:underline',
    always: 'underline',
} as const

/**
 * Âncora com a aparência do `Link` do MUI — cor `primary` e sublinhado. Rota
 * interna vai pelo `Link` do react-router; link externo, `mailto:`, `tel:` e
 * `target="_blank"` continuam sendo uma âncora comum.
 */
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
    ({ href, target, underline = 'always', className, ...props }, ref) => {
        const classes = cn(
            'cursor-pointer text-primary underline-offset-2',
            sublinhado[underline],
            className,
        )

        const externo =
            target === '_blank' ||
            href?.startsWith('http') ||
            href?.startsWith('mailto:') ||
            href?.startsWith('tel:')

        if (href && !externo) {
            return (
                <LinkRouter
                    {...props}
                    ref={ref}
                    to={href}
                    className={classes}
                />
            )
        }

        return (
            <a
                {...props}
                ref={ref}
                href={href}
                target={target}
                rel={target === '_blank' ? 'noopener noreferrer' : undefined}
                className={classes}
            />
        )
    },
)

Link.displayName = 'Link'
